var exports = {
  "qr": "xa15a2ab7--3d6301--footer",
  "Hw": "xa15a2ab7--3d6301--mobile",
  "x6": "xa15a2ab7--3d6301--button",
};

module.exports = exports;
